module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2023_02.ac83eed9.webp";